import { EImportSectionsTarget, EModalSectionMode } from '@constants';
import type { ICourse } from '@sdk/contracts';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { ModalSection } from '../ModalSection';

import { useAddSection } from './useAddSection';

import { Icon } from '@/components/Icon';

type AddSectionProps = {
  course: ICourse;
  target: EImportSectionsTarget;
};

export const AddSection: React.FC<AddSectionProps> = ({ course, target }) => {
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');
  const { isIntroduction, isWorking, handleSubmit, isOpen, setIsOpen } = useAddSection({
    course,
    target
  });

  return (
    <>
      <Button size="middle" type="primary" onClick={() => setIsOpen(true)} icon={<Icon i="Add" />}>
        {t('CREATE_SECTION')}
      </Button>
      <ModalSection
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
        mode={EModalSectionMode.CREATE}
        isLoading={isWorking}
        hideDescription={isIntroduction}
      />
    </>
  );
};
